import { message } from "antd";
import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import { constructParams } from "./constructParams";
import { GetDashboardSigupChartData } from "../../../utils/api";
import Loader from "../../shared/Loader";

const options = {
  responsive: true,
  scales: {
    y: {
      border: { dash: [4, 4] },
      ticks: {
        display: true,
        // stepSize: 100,
      },
    },
    x: {
      grid: {
        display: false,
      },
      ticks: {
        display: true,
      },
    },
  },
  plugins: {
    legend: {
      display: false,
    },
    title: {
      display: false,
    },
  },
};

const TotalSignupsChart = ({ selectedOption, startDate, endDate }) => {
  const [signUpData, setSignUpData] = useState({
    period: [],
    clientData: [],
    providerData: [],
  });
  const [loading, setLoading] = useState(true);

  const fetch = async (params) => {
    try {
      setLoading(true);
      const queryParams = new URLSearchParams(params).toString();
      const response = await GetDashboardSigupChartData(queryParams);
      const mappedData = response?.items?.map((item) => ({
        date: item.date,
        clientCount: item.clientCount,
        providerCount: item.providerCount,
      }));
      setSignUpData((prevState) => ({
        ...prevState,
        period: mappedData?.map((item) => item.date),
        clientData: mappedData?.map((item) => item.clientCount),
        providerData: mappedData?.map((item) => item.providerCount),
      }));
      setLoading(false);
    } catch (error) {
      setLoading(false);
      message.error(error || "Unknown error occured. Please try again later.");
    }
  };

  useEffect(() => {
    const params = constructParams(selectedOption, startDate, endDate);
    fetch(params);
  }, [selectedOption, startDate, endDate]);

  const totalSignupChartData = {
    labels: signUpData?.period,
    datasets: [
      {
        label: "Clients",
        data: signUpData?.clientData,
        backgroundColor: "#56D863",
        borderColor: "transparent",
        borderWidth: 2,
        barThickness: 13,
      },
      {
        label: "Service Providers",
        data: signUpData?.providerData,
        backgroundColor: "#FFC400",
        borderColor: "transparent",
        borderWidth: 2,
        barThickness: 13,
      },
    ],
  };
  return (
    <div className="box-shadow sm:w-6/12 w-full rounded-xl flex-1 p-4">
      <div className="flex items-center text-xs">
        <h2 className="text-sm font-semibold text-[#272727]">Total Signups</h2>
        <div className=" sm:flex hidden flex-1 justify-center gap-x-8 2xl:gap-x-16">
          <div className="flex gap-x-1 items-center">
            <div className="w-2 h-2 rounded-full bg-green" />
            <p className="text-[10px]">Clients</p>
          </div>
          <div className="flex gap-x-1 items-center">
            <div className="w-2 h-2 rounded-full bg-yellow-900" />
            <p className="text-[10px]">Service Providers</p>
          </div>
        </div>
      </div>

      <div className="w-full flex items-center justify-center mt-1">
        {loading ? (
          <Loader height="h-[40vh]" />
        ) : (
          <Bar data={totalSignupChartData} options={options} />
        )}
      </div>
    </div>
  );
};

export default TotalSignupsChart;
